import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { SlideBarItemComponent } from "./slide-bar-item/slide-bar-item.component";
import "./slide-bar.scss";
import { Subscription } from "rxjs";
import { useTranslation } from "react-i18next";
import { APP_CONFIGS } from "src/common/configs/app-configs";
import EventBus, {
  EventBusType,
  EventBusName,
} from "src/common/eventbus/event-bus";
import usePermissionStatus from "src/common/hooks/usePermissionStatus";
import localStorageHelpers, {
  StorageKey,
} from "src/common/storage/local-storage-helpers";
import { ENUM_PAGE } from "src/libraries/enums/pages";
import { ROLE } from "src/libraries/enums/role";
import {
  IconDeleteDisabled,
  VersionControlIcon,
  TicketSupport,
} from "src/libraries/icons/icon";
import {
  Logo,
  MenuIcon,
} from "src/libraries/icons/svg/slide-bar-icon/side-bar.icon";

import { IoBusiness, IoHome } from "react-icons/io5";
import { RiBillFill, RiWalletFill, RiBankFill } from "react-icons/ri";

export const SlideBarComponent = () => {
  const [active, SetActive] = useState<boolean>(true);
  const [collapsedAdmin, setCollapsedAdmin] = useState<boolean>(false);
  const [role, setRole] = useState<string>();
  const subscriptions = new Subscription();

  useEffect(() => {
    document.getElementById("slidebar")?.classList.toggle("active", active);
    document
      .getElementById("slidebar-header")
      ?.classList.toggle("active", active);
    document
      .getElementById("slidebar-header-icon")
      ?.classList.toggle("active", active);
    document.getElementById("version_text")?.classList.toggle("active", active);
    var items = document.getElementsByClassName("slidebar-item");
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle("active", active);

      var child = items[i].children;
      for (var j = 0; j < child.length; j++) {
        child[j].classList.toggle("active", active);
      }
    }
  }, [active]);

  useEffect(() => {
    EventBusSubCription();
  }, []);

  useEffect(() => {
    return () => {
      subscriptions.unsubscribe();
    };
  }, []);

  const EventBusSubCription = () => {
    subscriptions.add(
      EventBus.getInstance().events.subscribe((res: EventBusType) => {
        console.log("RES slide", res);

        switch (res?.type) {
          case EventBusName.UPDATE_USER_INFO:
            getUserRole();
            break;
        }
      })
    );
  };

  const getUserRole = async () => {
    const data = await localStorageHelpers.get(StorageKey.USER_INFO);
    const result = JSON.parse(data);
    setRole(result.tenant_id);
  };

  useEffect(() => {
    getUserRole();
  }, []);

  useEffect(() => {
    const resizeWindow = () => {
      window.innerWidth <= 1030 ? SetActive(false) : SetActive(true);
    };
    window.addEventListener("resize", resizeWindow);
    resizeWindow();
    console.log(window.innerWidth);
  }, []);

  return (
    <>
      <div className="slidebar" id="slidebar">
        <div className="slidebar-header" id="slidebar-header">
          <div
            className="slidebar-header-icon"
            id="slidebar-header-icon"
            onClick={() => {
              SetActive(!active);
            }}
          >
            <img
              src={require("../../assets/logo.png")}
              width={90}
              alt="hyper-logo"
            />
            {/* <Logo /> */}
          </div>
          <div
            className={"slidebar-menu-icon" + (active ? " active" : "")}
            onClick={() => {
              SetActive(!active);
            }}
          >
            <MenuIcon />
          </div>
          <IconDeleteDisabled
            className={"closeIcon" + (active ? " active" : "")}
            onClick={() => {
              SetActive(!active);
            }}
          />
        </div>
        <div className="slidebar-body">
          <ul>
            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink exact to={ENUM_PAGE.HOME} activeClassName="active">
                <SlideBarItemComponent
                  name={"Trang chủ"}
                  icon={<IoHome color="#fff" size={20} />}
                />
              </NavLink>
            </li>
            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.MERCHANT} activeClassName="active">
                <SlideBarItemComponent
                  name={"Merchant"}
                  icon={<IoBusiness color="#fff" size={20} />}
                />
              </NavLink>
            </li>
            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.TRANSACTION} activeClassName="active">
                <SlideBarItemComponent
                  name={"Giao dịch"}
                  icon={<RiBillFill color="#fff" size={20} />}
                />
              </NavLink>
            </li>
            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.BANK} activeClassName="active">
                <SlideBarItemComponent
                  name={"Ngân hàng"}
                  icon={<RiBankFill color="#fff" size={20} />}
                />
              </NavLink>
            </li>
            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.CHANNEL} activeClassName="active">
                <SlideBarItemComponent
                  name={"Kênh thanh toán"}
                  icon={<RiWalletFill color="#fff" size={20} />}
                />
              </NavLink>
            </li>
            {/* <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.REFUND} activeClassName="active">
                <SlideBarItemComponent
                  name={"Yêu cầu hoàn trả"}
                  icon={<RiRefund2Line color="#fff" size={20} />}
                />
              </NavLink>
            </li>

            <li
              onClick={() => {
                window.innerWidth <= 1030 && SetActive(!active);
              }}
            >
              <NavLink to={ENUM_PAGE.COMPLAIN} activeClassName="active">
                <SlideBarItemComponent
                  name={"Khiếu nại"}
                  icon={<MdOutlineStickyNote2 color="#fff" size={20} />}
                />
              </NavLink>
            </li>

            {checkAdmin() && (
              <li>
                <div
                  className={`report-sidebar-dropdown-toggle ${
                    collapsedAdmin ? `collapsed` : ``
                  }`}
                  onClick={() => setCollapsedAdmin(!collapsedAdmin)}
                >
                  <NavLink
                    to={ENUM_PAGE.ADMIN_MANAGEMENT_EMPLOYEE}
                    activeClassName="active"
                  >
                    <SlideBarItemComponent
                      name={"Quản trị"}
                      icon={<MdManageAccounts color="#fff" size={20} />}
                    />
                  </NavLink>
                </div>
                <div
                  className={`sidebar-dropdown-item ${
                    collapsedAdmin ? "collapsed_entered" : ""
                  }`}
                >
                  <NavLink
                    to={ENUM_PAGE.ADMIN_MANAGEMENT_EMPLOYEE}
                    activeClassName="active"
                    onClick={() => {
                      window.innerWidth <= 1030 && SetActive(!active);
                    }}
                  >
                    <SlideBarItemComponent name={"Quản trị user"} />
                  </NavLink>
                  <NavLink
                    to={ENUM_PAGE.ADMIN_MANAGEMENT_PERMISSION}
                    activeClassName="active"
                    onClick={() => {
                      window.innerWidth <= 1030 && SetActive(!active);
                    }}
                  >
                    <SlideBarItemComponent name={"Quản trị quyền"} />
                  </NavLink>
                </div>
              </li>
            )} */}
          </ul>
        </div>
      </div>
    </>
  );
};
